var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLumateLogoLt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 290,
    height: 47,
    viewBox: "0 0 290 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.346924 -0.0286255H6.38763V40.9111H29.6752V46.9518H0.346924V-0.0286255Z",
    fill: "#447EBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1991 23.5C52.1554 23.5 46.8604 26.7072 43.9229 31.5126C43.953 31.5879 43.9846 31.6648 44.0163 31.7401C46.3467 37.2355 51.714 40.9126 58.1991 40.9126C64.6842 40.9126 70.2187 37.1406 72.4829 31.5247C69.5469 26.7132 64.2488 23.5015 58.1991 23.5015V23.5Z",
    fill: "#FDE100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6352 -0.0301208V25.4764C73.6352 27.6306 73.2315 29.6537 72.4994 31.484C70.2443 37.1225 64.8378 40.9126 58.199 40.9126C51.5603 40.9126 46.3466 37.237 44.0162 31.7401C43.2117 29.8435 42.7643 27.7315 42.7643 25.4764V-0.0301208H36.7236V25.4764C36.7236 30.9718 38.6247 35.8586 41.8078 39.584C45.7003 44.1393 51.5181 46.9533 58.2005 46.9533C64.883 46.9533 70.9719 44.0369 74.8524 39.3233C77.8893 35.6326 79.6774 30.8407 79.6774 25.4764V-0.0301208H73.6367H73.6352Z",
    fill: "#447EBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4292 -0.0286255H98.4699L121.021 39.1667L143.504 -0.0286255H149.545V46.9533H143.504V12.3872L123.638 46.9518H118.335L98.4684 12.3872V46.9518H92.4277V-0.0286255H92.4292Z",
    fill: "#447EBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.878 38.0248H170.421L166.258 46.9518H159.615L181.494 -0.0286255H187.803L209.684 46.9533H203.039L198.878 38.0263V38.0248ZM196.126 31.9856L184.649 7.2865L173.173 31.9856H196.126Z",
    fill: "#447EBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.46 6.01208H208.002V-0.0286255H251.024V6.01208H232.501V46.9533H226.46V6.01208Z",
    fill: "#447EBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.755 -0.0286255H289.615V6.01208H266.798V20.442H289.615V26.4827H266.798V40.9126H289.615V46.9533H260.755V-0.0286255Z",
    fill: "#447EBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 289.231,
    height: 47,
    fill: "white",
    transform: "translate(0.384644)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLumateLogoLt1);
export default __webpack_public_path__ + "static/media/Lumate-Logo-lt 1.a1ea7e8a32a317258a63d544093d0ca0.svg";
export { ForwardRef as ReactComponent };